export function isStaging() {
  return window.location.hostname.match(/staging/);
}

export function isE2E() {
  return process.env.NODE_ENV === 'test';
}
